import type { Dispatch } from "react-redux";
import herdService from "services/herdService";
import { getErrorMessage } from "shared/errorUtils";
import {
  type AgeRangeDispatchAction,
  listAgeRanges,
  notifyError,
} from "../actions";

export const fetchAgeRanges =
  () => async (dispatch: Dispatch<AgeRangeDispatchAction>) => {
    try {
      const ageRanges = await herdService.listAgeRanges();

      const sortedAgeRanges = ageRanges.data.sort((a, b) =>
        a.ageRange.localeCompare(b.ageRange, undefined, { numeric: true })
      );

      dispatch(listAgeRanges(sortedAgeRanges));
    } catch (error) {
      const message = getErrorMessage(error);
      dispatch(notifyError({ mensagem: message }));
    }
  };
